import { render } from "./ScorePHQ9.vue?vue&type=template&id=188bd3de&scoped=true"
import script from "./ScorePHQ9.vue?vue&type=script&lang=js"
export * from "./ScorePHQ9.vue?vue&type=script&lang=js"

import "./ScorePHQ9.vue?vue&type=style&index=0&id=188bd3de&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-188bd3de"]])

export default __exports__